import { withAuthentication } from "@/lib/auth0/withAuthentication";
import { Outlet, createFileRoute } from "@tanstack/react-router";

function Auth() {
  return <Outlet />;
}

export const Route = createFileRoute("/_auth")({
  component: withAuthentication(Auth)
});
